var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHexagonYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 38,
    viewBox: "0 0 42 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_bii_2136_194724)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.975643 22.6094C-0.325214 20.3752 -0.325214 17.6248 0.975643 15.3906L7.82861 3.62105C9.13311 1.38066 11.5474 1.37702e-07 14.1606 1.68864e-07L27.8394 3.31981e-07C30.4526 3.63143e-07 32.8669 1.38066 34.1714 3.62105L41.0244 15.3906C42.3252 17.6248 42.3252 20.3753 41.0244 22.6094L34.1714 34.3789C32.8669 36.6193 30.4526 38 27.8394 38L14.1606 38C11.5474 38 9.13311 36.6193 7.82861 34.3789L0.975643 22.6094Z",
    fill: "#E9BE5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.46832 21.7403C1.48026 20.0433 1.48026 17.9567 2.46832 16.2597L9.32129 4.49018C10.3134 2.78635 12.1562 1.72727 14.1606 1.72727L27.8394 1.72727C29.8438 1.72727 31.6866 2.78635 32.6787 4.49018L39.5317 16.2597C40.5197 17.9567 40.5197 20.0433 39.5317 21.7403L32.6787 33.5098C31.6866 35.2136 29.8438 36.2727 27.8394 36.2727L14.1606 36.2727C12.1562 36.2727 10.3134 35.2136 9.32129 33.5098L2.46832 21.7403Z",
    stroke: "#E9BE5C",
    strokeWidth: 3.45455
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_bii_2136_194724",
    x: -28.4422,
    y: -28.4422,
    width: 98.8845,
    height: 94.8845,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 14.2211
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_2136_194724"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_2136_194724",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.37573
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.18786
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect2_innerShadow_2136_194724"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 37.1937
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.05 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect2_innerShadow_2136_194724",
    result: "effect3_innerShadow_2136_194724"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHexagonYellow);
export default __webpack_public_path__ + "static/media/hexagon-yellow.8c268deb09fb2eaff5ee9da3546d8579.svg";
export { ForwardRef as ReactComponent };